import {useState} from "react";
import {SimCardStatus} from "../../../models/SimCardStatus";
import {SetSingleStatusForm} from "./SetSingleStatusForm";
import {Rest} from "../../../../../models/common";
import {IHandleCloseProps} from "../../../models/Modal";

interface ISetStatusProps extends Rest {
    msisdn: string | undefined
    status: SimCardStatus | undefined
    onFinish: () => void
}

/**
 * Установка/снятие блокировки одного номера (SIM-карты)
 */
export const SetSingleStatus = ({msisdn, status, onFinish, ...rest}: ISetStatusProps) => {
    const [show, setShow] = useState(false)

    const closeModal = ({isSubmitted}: IHandleCloseProps) => {
        setShow(false)
        isSubmitted && onFinish()
    }

    return (
        <>
            {status &&
            <button
                type='button'
                style={{marginLeft: "10px"}}
                className={rest.className || 'btn btn-primary'}
                onClick={() => setShow(true)}
            >
                {status === SimCardStatus.ACTIVE ? 'Блокировать' : 'Разблокировать'}
            </button>
            }
            {show &&
            <SetSingleStatusForm
                msisdn={msisdn}
                status={status}
                statusChangeAllowed={rest.statusChangeAllowed}
                show={show}
                handleClose={closeModal}
                onChange={onFinish}
            />
            }
        </>
    )
}
